import { useEffect, useState } from "react";
import { api, act, useFetch } from "@/lib/api";
import { PageHeader, Panel, Badge, Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Microsoft365Panel } from "@/components/Microsoft365Panel";
import { DeliveryPanel } from "@/components/DeliveryPanel";
import { BrandKitPanel } from "@/components/BrandKitPanel";
import { SocialPanel } from "@/components/SocialPanel";
import { AccessPanel } from "@/components/AccessPanel";
import { SendersPanel, AzureEmailPanel } from "@/components/SendersPanel";

export default function Settings() {
  const { data: me } = useFetch("/me");
  const { data: ints } = useFetch("/integrations");
  const { data: s, reload } = useFetch("/settings");
  const [f, setF] = useState(null);
  useEffect(() => { if (s) setF({ company_name: s.company_name, website: s.website, default_signature: s.default_signature, reps: JSON.stringify(s.reps, null, 2), internal_domains: (s.internal_domains || []).join(", ") }); }, [s]);
  const save = async () => {
    let reps;
    try { reps = JSON.parse(f.reps); } catch { return act(() => Promise.reject(new Error("Reps must be valid JSON"))); }
    await act(() => api.patch("/settings", { ...f, reps, internal_domains: f.internal_domains.split(",").map((x) => x.trim()).filter(Boolean) }), "Settings saved");
    reload();
  };
  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Integrations & settings" title="Connectors" desc="The platform owns policy, memory and orchestration; channel infrastructure is integrated. Unsupported access is never simulated silently." />
      <div className="grid lg:grid-cols-2 gap-3">
        <Microsoft365Panel reps={s?.reps} />
        <DeliveryPanel />
        <SendersPanel isAdmin={me?.role === "admin"} />
        <AzureEmailPanel isAdmin={me?.role === "admin"} />
        <BrandKitPanel />
        <SocialPanel />
        <Panel title="Integrations">
          <div className="divide-y divide-border/60">{(ints || []).map((i) => (
            <div key={i.key} className="py-2.5 flex items-center gap-3" data-testid={`integration-${i.key}`}><div className="flex-1"><div className="text-sm">{i.name}</div><div className="text-[11px] text-zinc-500">{i.detail}</div></div><Badge v={i.status} /></div>
          ))}</div>
        </Panel>
        {f && <Panel title="Company & reps">
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <Field label="Company name (sender identification)"><Input data-testid="settings-company-input" value={f.company_name || ""} onChange={(e) => setF({ ...f, company_name: e.target.value })} className="bg-black" /></Field>
              <Field label="Website"><Input value={f.website || ""} onChange={(e) => setF({ ...f, website: e.target.value })} className="bg-black" /></Field>
            </div>
            <Field label="Internal domains (replies from these never trigger prospect automation)"><Input data-testid="settings-internal-domains" value={f.internal_domains} onChange={(e) => setF({ ...f, internal_domains: e.target.value })} className="bg-black" /></Field>
            <Field label="Default signature"><Textarea rows={2} value={f.default_signature || ""} onChange={(e) => setF({ ...f, default_signature: e.target.value })} className="bg-black" /></Field>
            <Field label="Sales reps (JSON: name, email, timezone)"><Textarea data-testid="settings-reps-input" rows={7} value={f.reps} onChange={(e) => setF({ ...f, reps: e.target.value })} className="bg-black font-mono text-xs" /></Field>
            <Button data-testid="settings-save-btn" onClick={save} className="bg-[#007AFF] hover:bg-[#3395FF]">Save settings</Button>
          </div>
        </Panel>}
        {me?.role === "admin" && <AccessPanel />}
        <Panel title="Your account"><div className="text-sm">{me?.email} <Badge v={me?.role} tone="blue" /></div></Panel>
      </div>
    </div>
  );
}
